import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const mailing = {

  namespaced: true,

  state: {
    mailing: {},
  },

  getters: {
    mailing: state => state.mailing,
  },

  mutations: {
    setMailing(state, mailing) { state.mailing = mailing },
    setPublish(state, publish) { state.mailing.publish = publish },
  },

  actions: {

    async getMailing({ commit }) { 
      const mailing = await Vue.axios.get(API_URL + '/mailings/' + router.currentRoute.params.id)
      commit('setMailing', mailing.data);
      commit('setProgress', false, { root: true });
    },

  }
}
